import { render, staticRenderFns } from "./FileMgmt.vue?vue&type=template&id=878316b6&scoped=true&"
import script from "./FileMgmt.vue?vue&type=script&lang=ts&"
export * from "./FileMgmt.vue?vue&type=script&lang=ts&"
import style0 from "./FileMgmt.vue?vue&type=style&index=0&id=878316b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878316b6",
  null
  
)

export default component.exports